export default __webpack_public_path__ + "static/media/HEROES_TEXT.517fb41e.png";